import React from 'react';

import { useIntl } from 'react-intl';

import { StyledModalHeader } from '../styled';

export const DeliveryAddressFormHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <StyledModalHeader id="modal-heading">
        {formatMessage({ id: 'enterYourDeliveryAddress' })}
      </StyledModalHeader>
    </>
  );
};
